import Vue from "vue";
import Router from "vue-router";
import Home from "./views/home";
import About from "./views/about";
import Videos from "./views/sca-videos-view.vue";

import Ongoinglearning from "./views/ongoinglearning";
import Resourses from "./views/resourses";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
       path: '/coffee-academy/:id',
       component: Videos,
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/ongoinglearning",
      name: "ongoinglearning",
      component: Ongoinglearning
    }
    //,{
    //     path: '/resources',
    //     name: 'resourses',
    //     component: Resourses
    // }
  ]
});

export default router;
